/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

export function OverlayVideoPlayer({ video, closeVideo }) {
  const getUrl = () => {
    if (video?.fotbollplayUrl) {
      const splitUrl = video?.fotbollplayUrl?.split('/');
      const id = splitUrl?.[4];

      return `https://fotbollplay.se/embed/playlist/${id}`;
    }
    if (video?.id) {
      return `https://fotbollplay.se/embed/playlist/${video?.id}`;
    }

    if (video?.webUrl) {
      return video?.webUrl.replace('webview', 'embed');
    }
    return '';
  };

  if (video && video?.id) {
    return (
      <div className="content-backdrop content-backdrop--show">
        <div className="content-backdrop__content">
          <div id="video">
            <iframe
              src={getUrl()}
              allowFullScreen="true"
              allow="fullscreen"
              border="0"
              title={video?.title}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
              }}
            />
          </div>
          <div className="content-backdrop__close" onClick={closeVideo}>
            ✕
          </div>
        </div>
      </div>
    );
  }

  return null;
}
